import { useState, useEffect } from "react";
import { getAllCurrencies } from "app/shared/api";
import {
  CurrencyRefDto,
  normalizeCurrencies,
} from "../domain/currency/normalizeCurrency";

export interface UseCurrenciesResult {
  allCurrencies: CurrencyRefDto[];
  currenciesLoading: boolean;
  currenciesLoadError: string | null;
}

export function useCurrencies(): UseCurrenciesResult {
  const [allCurrencies, setAllCurrencies] = useState<CurrencyRefDto[]>([]);
  const [currenciesLoading, setCurrenciesLoading] = useState(false);
  const [currenciesLoadError, setCurrenciesLoadError] = useState<string | null>(
    null
  );

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        setCurrenciesLoading(true);
        setCurrenciesLoadError(null);

        const res = await getAllCurrencies();

        if (cancelled) return;

        setAllCurrencies(normalizeCurrencies(res));
      } catch (e: any) {
        if (cancelled) return;
        setAllCurrencies([]);
        setCurrenciesLoadError(String(e?.message ?? e));
      } finally {
        if (!cancelled) setCurrenciesLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { allCurrencies, currenciesLoading, currenciesLoadError };
}

export default useCurrencies;
